import { Component, Input, inject } from '@angular/core';
import {Router} from '@angular/router';

@Component({
    selector: 'app-explanation',
    templateUrl: './explanation.component.html',
    styleUrls: ['./explanation.component.scss'],
    standalone: false
})
export class ExplanationComponent {
    private router = inject(Router);


    @Input() link: string;

    public navigateToLink(): void {
        if (this.link) {
            this.router.navigate([this.link]);
        }
    }

}
